import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogContent, IconButton, DialogTitle as MuiDialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogWrapper = styled(Box)({
  padding: '35px 35px 25px 35px',
  backgroundColor: '#FBFBFB',
  width: '720px',
  color: 'black',
  display: 'flex',
  flexDirection: 'column'
});

export const DialogTitle = styled(MuiDialogTitle)({
  cursor: 'default',
  padding: '20px 0px 15px 5px'
});

export const CloseDialogButton = styled((props: any) => (
  <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} {...props}>
    <CloseIcon />
  </IconButton>
))(() => ({}));

export const DialogContentWrapper = styled(DialogContent)({
  border: 'solid 1px #f0f0f0',
  borderRadius: '10px',
  backgroundColor: 'white',
  padding: 0,
  display: 'flex',
  flexDirection: 'column'
});

export const DialogSubtitle = styled(Box)({
  fontSize: '16px',
  fontWeight: 500,
  cursor: 'default',
  display: 'flex',
  padding: '20px 30px'
});

export const StatusWrapper = styled('div')({
  fontSize: '16px',
  display: 'flex',
  flexDirection: 'row',
  fontWeight: 500,
  justifyContent: 'space-between',
  padding: '10px 30px 10px 30px',
  alignItems: 'center',
  cursor: 'default'
});
